<template>
  <div class="not-found-data">
   <span class="text">
    Страница недоступна, пожалуйста войдите в систему
   </span>
   <v-chip
      class="ma-2"
      color="indigo"
      text-color="white"
      @click="goToLogin">
      <v-avatar left>
        <v-icon>mdi-account-circle</v-icon>
      </v-avatar>
      авторизация
    </v-chip>
  </div>
</template>
<script>
export default {
  name: 'NotFoundPage',
  methods: {
    goToLogin() {
      this.$router.push('/login');
    },
  },
};
</script>
<style scoped>
  .not-found-data{
position: absolute;
    top:50%;
    left: 50%;
    transform: translate(-50%);

  }
  .text{
    color: #15336d;
    font-weight: bold;
    font-size: 18px;
  }
</style>
